import React from 'react';
import SearchFieldsActions from 'actions/search/SearchFieldsActions';
import 'styles/search/CallerTeamComboboxSearchField.styl';
import CallerTeamComboboxSearchFieldContainer from 'components/stateful/search/CallerTeamComboboxSearchFieldContainer';

/**
 * `ComboboxSearchWidgets` renders all the `ComboboxSearchField` components according to the special list of combobox
 * search listed by the business logic / mock-ups. At the moment, only the 'Caller' search field is a combobox which
 * includes 3 sub react-select components: 'Team', 'Rep' and 'Manager'
 */
class ComboboxSearchWidgets extends React.Component {
  searchFieldToggled(searchField) {
    if (this.props.searchFieldsToggled) {
      return this.props.searchFieldsToggled.get(searchField.name);
    }
    return false;
  }

  onUpdateSelectedOptionKey = (sf, key) => {
    SearchFieldsActions.updateComboboxSearchFieldSelectedOptionKey(sf, key);
  };

  /**
   * Render a combobox search field for the provided search field.
   * @param  {searchField} searchField The search field to render
   * @return {JSX} A combobox search widget.
   */
  renderComponent(searchField) {
    const searchFieldsState = this.props.searchFieldsState;
    return (
      <CallerTeamComboboxSearchFieldContainer
        key={searchField.name}
        searchField={searchField}
        toggled={this.searchFieldToggled(searchField)}
        searchFieldsState={searchFieldsState}
        updateLastToggledOnSearchWidget={this.props.updateLastToggledOnSearchWidget}
        shouldFocus={
          this.props.shouldRenderToggled &&
          this.searchFieldToggled(searchField) &&
          searchField.name === this.props.lastToggledOnSearchWidget
        }
        shouldSortByToggled={this.props.shouldSortByToggled}
        onUpdateSelectedOptionKey={this.onUpdateSelectedOptionKey}
      />
    );
  }

  /**
   * Returns a boolean that indicates whether the Search Field should not be rendered.
   * @return {boolean} When true indicates that the Search Field should not be rendered.
   */
  shouldNotRenderComponent(sf) {
    return !(
      (this.props.shouldRenderToggled && this.searchFieldToggled(sf)) ||
      (this.props.shouldRenderNotToggled && !this.searchFieldToggled(sf))
    );
  }

  render() {
    const searchFields = this.props.searchFields.sort(sf => sf.order);
    return (
      <div className="search-widget">
        {searchFields
          .filterNot(this.shouldNotRenderComponent, this)
          .map(this.renderComponent, this)}
      </div>
    );
  }
}

export default ComboboxSearchWidgets;
